import type { MultiPromotion, Promotion } from '../Promotions.types'

export const isPromotionMultiple = (promotion: Promotion): promotion is MultiPromotion =>
  promotion.type === 'MULTI'
